var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header-fixed"},[_c('router-link',{attrs:{"to":"/"}},[_c('div',{staticClass:"iconfont header-fixed-back"},[_vm._v("")])]),_vm._v(" "),_c('span',[_vm._v("北京必游TOP10")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d3ec8c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/category/components/Header.vue
// module id = null
// module chunks = 